/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Region_PlaceholderInputs */

const en_search_region_placeholder = /** @type {(inputs: Search_Region_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search region...`)
};

const es_search_region_placeholder = /** @type {(inputs: Search_Region_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar region...`)
};

/**
* | output |
* | --- |
* | "Search region..." |
*
* @param {Search_Region_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_region_placeholder = /** @type {((inputs?: Search_Region_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Region_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_region_placeholder(inputs)
	return es_search_region_placeholder(inputs)
});